import { useState } from "react";
import LoadingAnimation from "@assets/svg/LoadingAnimation";
import { markUnmarkFavoriteMatchedJobs } from "@endpoints/job.service";
import dayjs from "@lib/dayjs";
import { useSnackbar } from "notistack";
import AnimatedCircleProgress from "@components/AnimatedCircleProgress";
import { NavLink } from "react-router-dom";
import { StarIcon } from "lucide-react";
import StarFilledIcon from "@assets/svg/StarFilledIcon";
import { JobTypeEnum } from "@utils/constants";

const JobCard = ({ data, onClick }) => {
    const { enqueueSnackbar } = useSnackbar()
    const [isMarkedFavorite, setIsMarkedFavorite] = useState(data?.isMarkFavorite)
    const [isMarking, setIsMarking] = useState(false)

    const isAspiration = data?.tag === 'Aspiration'
    const isReferred = Boolean(data?.isReferred)

    const handleMarkUnmarkFavorite = async () => {
        try {
            setIsMarking(true)
            await markUnmarkFavoriteMatchedJobs({
                isMarkFavorite: !isMarkedFavorite,
                matchId: data?._id,
                tag: data?.tag
            })
            setIsMarkedFavorite((prev) => !prev)
        } catch (error) {
            enqueueSnackbar(error, { variant: 'error' })
        } finally {
            setIsMarking(false)
        }
    }

    return (
        <NavLink
            to={"/job-matches-details"}
            state={{ item: data }}
            onClick={onClick}
            className="grid grid-cols-[0.9fr_1.6fr_0.5fr] gap-10 items-center py-6 border-b pl-2 hover:bg-gray-50"
        >
            <div className="flex flex-col gap-1.5">
                <span className="text-xs italic text-light-black font-semibold mb-8">Posted By: &nbsp; &nbsp; <span className="text-charcoal">{data?.recruiterCompanyName}</span></span>
                <div className="flex items-center text-xs text-charcoal">
                    <span className="w-20 text-light-black">Location:</span>
                    <span>{data?.location || 'N/A'}</span>
                </div>
                <div className="flex items-center text-xs text-charcoal">
                    <span className="w-20 text-light-black">Job Type:</span>
                    <span>{JobTypeEnum[data?.jobType]}</span>
                </div>
                <div className="flex items-center text-xs text-charcoal">
                    <span className="w-20 text-light-black">Salary:</span>
                    <span>{data?.salary?.min} - {data?.salary?.max}</span>
                </div>
            </div>

            <div className="flex flex-col gap-2">
                <span className="text-sm font-bold text-charcoal mb-2">{data?.jobTitle}</span>
                <div className="flex items-center gap-5 h-[1rem]">
                    {data?.latestTrackerDetails?.createdAt || data?.matchedAt ? (
                        <>
                            <span className="text-xs text-light-black font-medium italic">
                                {dayjs(data?.latestTrackerDetails?.createdAt || data?.matchedAt).format("hh:mm a")}
                            </span>
                            <span className="text-xs text-light-black font-medium italic">
                                {dayjs(data?.latestTrackerDetails?.createdAt || data?.matchedAt).format("DD MMM YYYY")}
                            </span>
                        </>
                    ) : null}
                </div>
                <div className="flex items-center border border-gray-200 bg-gray-50 rounded-md h-[3.8rem] py-3 px-5">
                    <span className="text-xs font-medium text-charcoal">
                        Latest Activity : {data?.latestTrackerDetails?.status || 'Job Matched'}
                    </span>
                </div>
            </div>

            <div className="flex h-full gap-8">
                <div className="flex flex-col items-center gap-7">
                    <span className="text-xs font-medium text-charcoal bg-gray-50 rounded-md py-1.5 w-32 border text-center">
                        {isAspiration ? 'Aspirations' : 'Profile'} Match
                    </span>
                    {isReferred ? (
                        <span className="text-[10px] font-semibold px-3 py-1 rounded-full bg-green-50 text-green-700 border border-green-200 whitespace-nowrap">
                            Referred
                        </span>
                    ) : null}
                    <div className="relative">
                        <AnimatedCircleProgress
                            progress={data?.matchingPercentage}
                            suffix="%"
                            size={63}
                            textStyle="font-bold"
                        />
                    </div>
                </div>
                <div className="relative h-full w-10">
                    <button
                        onClick={(e) => {
                            e?.preventDefault()
                            e?.stopPropagation()
                            handleMarkUnmarkFavorite()
                        }}
                        className="hover:bg-gray-100 rounded-full p-1.5 absolute -top-5"
                    >
                        {
                            isMarking ?
                                <LoadingAnimation color="#2e2e2e" /> :
                                isMarkedFavorite ?
                                    <StarFilledIcon className={'h-5 w-5'} fill="#2e2e2e" />
                                    :
                                    <StarIcon color="#2e2e2e" size={20} strokeWidth={1} />
                        }
                    </button>
                </div>
            </div>


        </NavLink>
    );
};

export default JobCard
